import React from 'react';
import { Typography, CircularProgress } from '@common-ui/ui';
import { CheckCircle, Flag } from '@mui/icons-material';

const IconState = {
  Success: () => <CheckCircle color="success" />,
  Pending: () => <Flag color="warning" />,
  Loading: () => <CircularProgress size="1.5rem" />,
};

function StepState({ isLoading = true, notification, isChecked }) {
  const { success, pending } = notification || {};
  const Success = () => (
    <>
      <IconState.Success />
      <Typography sx={{ color: 'gray' }}>{success}</Typography>
    </>
  );

  const Pending = () => (
    <>
      {isLoading ? <IconState.Loading /> : <IconState.Pending />}
      <Typography sx={{ fontWeight: 'bold' }}>{pending}</Typography>
    </>
  );

  return isLoading ? <Pending /> : isChecked ? <Success /> : <Pending />;
}

export default function NotificationStep({ isChecked, notification, isLoading = false }) {
  return (
    <div id="step-notification-step" style={styleNotification}>
      <StepState isChecked={isChecked} isLoading={isLoading} notification={notification} />
    </div>
  );
}

const styleNotification = {
  width: '100%',
  display: 'flex',
  alignItems: 'left',
  gap: '4px',
  paddingBottom: '6px',
};
